export const SET_SOCKET = "SET_SOCKET";
export const CLEAR_SOCKET = "CLEAR_SOCKET";

export function setSocket(data) {
    return {
        type: SET_SOCKET,
        data
    }
}

export function clearSocket(data) {
    return {
        type: CLEAR_SOCKET,
        data
    }
}